import axios from 'axios'
import { Message } from 'element-ui'
import service from './index'
// service 循环遍历输出不同的请求方法
let instance = axios.create({
    // eslint-disable-next-line no-undef
    baseURL: config.ip,
    timeout: 10000,
    headers: {
        os: 'pc',
    },
})
const Http = {} // 包裹请求方法的容器

// 请求格式/参数的统一
for (let key in service) {
    let api = service[key] // url method
    // async 作用：避免进入回调地狱
    Http[key] = async function (
        params, // 请求参数 get：url，post
        isFormData = false, // 标识是否是form-data请求
        config = {}, // 配置参数
        timeout
    ) {
        let newParams = {}

        //  content-type是否是form-data的判断
        if (params && isFormData) {
            newParams = new FormData()
            for (let i in params) {
                newParams.append(i, params[i])
            }
        } else {
            newParams = params
        }
        // 不同请求的判断
        let response = {} // 请求的返回值
        if (api.method === 'post') {
            try {
                response = await instance[api.method](
                    api.url,
                    newParams,
                    config
                )
            } catch (err) {
                response = err
            }
        } else if (api.method === 'get') {
            config.params = newParams
            if (timeout !== undefined && timeout !== null) {
                config.timeout = timeout
            }
            try {
                response = await instance[api.method](api.url, config)
            } catch (err) {
                response = err
            }
        }

        if (response) {
            const code = response.code
            //100,101,104,105为登录接口错误码提示处理，117数据校验失败,108删除校验
            if (code === 0) {
                return response
            } else {
                let msg = response.msg
                if (msg) {
                    Message({
                        message: msg,
                        type: 'error',
                        duration: 3000,
                    })
                }
            }
        }
    }
}
// 响应拦截器
instance.interceptors.response.use(
    (res) => {
        // 请求成功
        return res.data
    },
    (error) => {
        // 失败处理
        return error.response.data
    }
)

export default Http
